import {
  type ReactElement,
  type ReactNode
} from 'react'
import { SpaceConsumer } from '../../SpaceContext/SpaceContext'
import { AuthConsumer } from '../AuthContext'
import type { Role } from '../types'
import { defaultAllowedRoles } from './constants'

interface Base {
  allowedRoles?: Role[]
  children: ReactElement | string // string type is use for lable
}

interface UnhideUnaccessibleProps {
  isHiddenIfDenied?: false
  placeholder?: never
}

interface HideUnaccessibleProps {
  isHiddenIfDenied: true
  placeholder?: ReactNode | string
}

type Props = Base & (UnhideUnaccessibleProps | HideUnaccessibleProps)

const SpaceAccessControl = ({
  allowedRoles = defaultAllowedRoles,
  isHiddenIfDenied = false,
  children,
  placeholder
}: Props) => (
  <SpaceConsumer>
    {
      context =>
        <AuthConsumer>
          {
            ({ accessibleRoles }) => {
              const disabledProps = {
                isDisabled: true
              }

              const getKeycloakAccessibility = () => {
                if (!accessibleRoles?.length) return children // cypress will not have any user role, when this happen just return children to pass cypress

                const isAccessible = accessibleRoles.some(accessibleRole =>
                  allowedRoles.includes(accessibleRole)
                )

                if (isAccessible) return children

                if (isHiddenIfDenied) return placeholder || null

                if (typeof children === 'string') return children

                return (
                  <children.type
                    {...(children.props as any)}
                    {...disabledProps}
                  />
                )
              }

              if (import.meta.env.MODE === 'test' || import.meta.env.VITE_IS_AUTH_DISABLED === 'true') {

                return getKeycloakAccessibility()
              }

              const spaceRole = context.role

              if (!spaceRole) return children

              const isAccessible = allowedRoles.includes(spaceRole)

              if (isAccessible) return children

              if (isHiddenIfDenied) return placeholder || null

              if (typeof children === 'string') return children

              return (
                <children.type
                  {...(children.props as any)}
                  {...disabledProps}
                />
              )
            }
          }
        </AuthConsumer>
    }
  </SpaceConsumer>
)

export default SpaceAccessControl
